module.exports = __webpack_public_path__ + "static/media/SERIELJP.e54bea02.jpg";